import React from 'react';
import SettingContainer from '@src/containers/Setting';

const Setting = () => <SettingContainer />;

export default Setting;
